import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import type {SxProps} from '@mui/system';
import type {FC} from 'react';

export type UploadFileButtonProps = {
  placeholder: string;
  file?: File;
  onFileSelected: (file?: File) => void;
  acceptMimeType?: string;
};

const UploadFileButton: FC<UploadFileButtonProps> = ({placeholder, file, onFileSelected, acceptMimeType}) => {
  const buttonLabel = file ? file.name : placeholder;

  return (
    <Tooltip title={buttonLabel}>
      <Button
        component="label"
        variant="contained"
        startIcon={<CloudUploadIcon />}
        onClick={() => {}}
        sx={styles.uploadGeometryButton}
      >
        {buttonLabel}
        <input
          type="file"
          accept={acceptMimeType}
          onChange={(event) => onFileSelected(event.target.files?.[0])}
          hidden
        />
      </Button>
    </Tooltip>
  );
};

export default UploadFileButton;

const styles: Record<string, SxProps> = {
  uploadGeometryButton: {
    mb: '0.75rem',
    color: 'primary.main',
    backgroundColor: 'common.white',
    borderRadius: '0%',
    boxShadow: 0,
  },
};
